/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetFleetsFleetIdMembersNotFound
 */
export interface GetFleetsFleetIdMembersNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetFleetsFleetIdMembersNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetFleetsFleetIdMembersNotFound interface.
 */
export function instanceOfGetFleetsFleetIdMembersNotFound(value: object): value is GetFleetsFleetIdMembersNotFound {
    return true;
}

export function GetFleetsFleetIdMembersNotFoundFromJSON(json: any): GetFleetsFleetIdMembersNotFound {
    return GetFleetsFleetIdMembersNotFoundFromJSONTyped(json, false);
}

export function GetFleetsFleetIdMembersNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFleetsFleetIdMembersNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetFleetsFleetIdMembersNotFoundToJSON(json: any): GetFleetsFleetIdMembersNotFound {
    return GetFleetsFleetIdMembersNotFoundToJSONTyped(json, false);
}

export function GetFleetsFleetIdMembersNotFoundToJSONTyped(value?: GetFleetsFleetIdMembersNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

